<template>
  <div
    :class="{
      't-calc': true,
      't-calc_ready': true,
      't-calc_design': !success,
      't-calc_upper': !success,
      't-calc_form': !success,
      't-calc_success': success,
    }"
  >
    <OQPanel
      :title="`Расчет стоимости &quot;${goods_name}&quot;`"
      v-if="!success"
    >
      <OQHint>
        После оформления заявки мы свяжемся с вами для уточнения деталей и
        сориентируем по итоговой стоимости. Пн-Пт: 10-19.
      </OQHint>
      <div class="o-form">
        <div class="o-form__block o-form__block_dual">
          <OQFioInput label="Имя Фамилия" :required="true" v-model="fio" />
          <OQEmailInput
            label="Email"
            :required="false"
            v-model="email"
            @hasError="(v) => (invalidEmail = v)"
          />
        </div>
        <OQPhoneInput
          label="Телефон"
          v-model="phone"
          placeholder="+7 (800) 555-35-35"
          :required="true"
          :with-confirmation="true"
          :confirm-api="phoneConfirmApi"
        />
        <OQTextInput label="Комментарий" v-model="comment" />
        <OQSimpleFileUploader v-model="files" />
        <OQCheckbox v-model="agreement">
          Я согласен с
          <a
            href="https://copy.spb.ru/about/politika_konfidencialnosti/"
            target="_blank"
          >
            политикой конфиденциальности
          </a>
        </OQCheckbox>
        <OQButton
          :disabled="
            !agreement ||
            phone.confirmed !== true ||
            !fio ||
            (email && invalidEmail) ||
            files.some((f) => f.progress !== undefined)
          "
          @click="doSendForm"
          variant="main"
        >
          Отправить
        </OQButton>
        <div class="t-calc__info t-calc__info_bottom-line">
          <span>Поля, отмеченные&nbsp;* - обязательны для заполнения</span>
        </div>
      </div>
    </OQPanel>
    <OQPanel title="Ваша заявка принята" v-else>
      <OQHint>
        Менеджер свяжется с вами по номеру {{ phone.phone }} в ближайшее время
      </OQHint>
    </OQPanel>
  </div>
</template>

<script>
import OQPanel from "@/components/UI/OQPanel.vue";
import OQHint from "@/components/UI/OQHint.vue";
import OQFioInput from "@/components/UI/OQFioInput.vue";
import OQPhoneInput from "@/components/UI/OQPhoneInput.vue";
import OQTextInput from "@/components/UI/OQTextInput.vue";
import OQCheckbox from "@/components/UI/OQCheckbox.vue";
import OQButton from "@/components/UI/OQButton.vue";
import OQFeedbackApi from "@/api/OQFeedbackApi";
import OQSimpleFileUploader from "@/components/UI/OQSimpleFileUploader";
import OQEmailInput from "@/components/UI/OQEmailInput";

export default {
  name: "CorpProductForm",
  props: ["goods_name"],
  components: {
    OQButton,
    OQCheckbox,
    OQTextInput,
    OQPhoneInput,
    OQFioInput,
    OQHint,
    OQPanel,
    OQSimpleFileUploader,
    OQEmailInput,
  },
  data() {
    return {
      phoneConfirmApi: {
        request_code: OQFeedbackApi.requestPhoneCode,
        check_code: OQFeedbackApi.checkPhoneCode,
      },
      invalidEmail: false,
      email: "",
      fio: "",
      phone: {
        phone: "",
        code: "",
        confirmed: false,
        phone_id: undefined,
      },
      comment: "",
      files: [],
      agreement: false,
      loading: false,
      success: false,
      send_error: {},
    };
  },
  watch: {},
  methods: {
    doSendForm() {
      if (!this.loading) {
        this.loading = true;
        OQFeedbackApi.sendForm(
          this.fio,
          this.phone.phone,
          this.phone.phone_id,
          this.comment,
          this.agreement,
          this.files,
          "corp_product",
          {
            goods_name: this.goods_name,
            from_url:
              document.referrer.toString() || window.location.href.toString(),
            this_url: window.location.href.toString(),
            email: this.email,
          }
        )
          .then((r) => {
            if (r.status === "ok") {
              this.success = true;
            } else {
              this.send_error = r.info;
            }
          })
          .finally(() => (this.loading = false));
      }
    },
    // Попробуйте через 10 мин.
  },
};
</script>

<style scoped lang="scss"></style>
